import { startLoading, stopLoading } from 'components/Loader/LoaderPopup/reducer'
import { requireCinemaId } from 'components/Modal/CinemaSelectWindow/saga'
import { setErrorMessage, setSuccessMessage } from 'components/Windows/CentralMessagesList/reducer'
import { API_LANGUAGE_MAPPING } from 'global/i18n/constants'
import { localeSelector } from 'global/i18n/selectors'
import { normalizeCinemaId } from 'global/helpers/cinemaList'
import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { callApiAsync } from 'services/api/callAPIAsync'
import { sendSms } from './reducer'

function* sendSmsCallSaga({ action, payload }) {
    const language = API_LANGUAGE_MAPPING?.[yield select(localeSelector)] ?? ''

    const ticket_numbers = payload?.itemsTickets
    const voucher_numbers = payload?.itemsVouchers
    const phone_number = payload?.phone
    const orderCinemaId = yield select((state) => state?.pages?.paymentVerify?.order?.cinemaid)
    const cinemaid = yield call(requireCinemaId, normalizeCinemaId(orderCinemaId) ?? payload?.transactionCinemaId)
    if (!cinemaid) return

    yield put(startLoading())

    const smsArgs = {
        language: language,
        cinemaid: cinemaid,
        ticket_numbers: ticket_numbers,
        voucher_numbers: voucher_numbers,
        phone_number: phone_number,
    }

    const { data: smsData, error: smsError } = yield call(callApiAsync, 'sendSms', smsArgs)

    yield put(stopLoading())
    if (smsError) {
        yield put(setErrorMessage('smsError'))
        return
    }
    if (!smsData.sms_sended) {
        console.warn('Sms is already in the db and waiting for send')
    }
    yield put(setSuccessMessage('SMS_SENDED'))
}

export default function* sendSmsSaga() {
    yield all([takeLatest(sendSms.type, sendSmsCallSaga)])
}
